import { useTranslation } from 'react-i18next'

import styles from './CalendlyStep.module.scss'

/**
 * Что человек видит сразу после заявки: не «мы свяжемся», а сам календарь.
 *
 * Раньше диалог показывал благодарность и закрывался через 2,2 секунды. Обещание «ответим в течение
 * рабочего дня» стоило нам шести заявок, на которые никто не ответил, — и даже когда автоответ
 * работает, самый заинтересованный человек находится ИМЕННО в эту секунду, а не завтра в почте.
 *
 * IFRAME, А НЕ ВИДЖЕТ CALENDLY. Их widget.js делает ровно одно: вставляет этот же iframe и добавляет
 * подгонку высоты по postMessage. Тянуть ради этого сторонний скрипт на лендинг не стоит — он
 * блокируется расширениями, весит и видит всю страницу. Плата за отказ: высоту приходится задать
 * самим, отсюда фиксированные 640px.
 *
 * Имя и почту подставляем в адрес: человек их только что ввёл, и заставлять вводить второй раз —
 * самый дешёвый способ потерять его на последнем шаге. Уходят они к Calendly, но именно для этой
 * встречи он их и оставил.
 *
 * Ссылка под календарём — не украшение. Iframe к calendly.com блокируют и корпоративные политики, и
 * блокировщики; без запасной ссылки такой человек упирается в пустой прямоугольник.
 */
const CALENDLY_URL = 'https://calendly.com/d-pokidov-intch/30min'

type Props = { name: string; email: string }

/** `direct` — календарь открыт из продукта без заявки (DemoStore `direct`): своя шапка, без «Request received». */
type StepProps = Props & { direct?: boolean }

const bookingUrl = ({ name, email }: Props) => {
  const url = new URL(CALENDLY_URL)
  url.searchParams.set('hide_gdpr_banner', '1')
  url.searchParams.set('embed_type', 'Inline')
  if (typeof window !== 'undefined') url.searchParams.set('embed_domain', window.location.hostname)
  if (name.trim()) url.searchParams.set('name', name.trim())
  if (email.trim()) url.searchParams.set('email', email.trim())
  return url.toString()
}

export const CalendlyStep = ({ name, email, direct = false }: StepProps) => {
  const { t } = useTranslation()

  return (
    <div className={styles.root}>
      <div className={styles.head}>
        <span className={styles.badge}>{direct ? t('landing.demo.booking.directBadge') : t('landing.demo.booking.badge')}</span>
        <h3 className={styles.title}>{direct ? t('landing.demo.booking.directTitle') : t('landing.demo.booking.title')}</h3>
        <p className={styles.sub}>{direct ? t('landing.demo.booking.directSub') : t('landing.demo.booking.sub')}</p>
      </div>

      <div className={styles.frame}>
        <iframe
          src={bookingUrl({ name, email })}
          title={t('landing.demo.booking.title')}
          loading="lazy"
        />
      </div>

      <p className={styles.fallback}>
        {t('landing.demo.booking.fallback')}{' '}
        <a href={CALENDLY_URL} target="_blank" rel="noreferrer noopener">
          {t('landing.demo.booking.fallbackLink')}
        </a>
      </p>
    </div>
  )
}
